<script>

import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import "@vueform/multiselect/themes/default.css";
import { hasModuleAccess, getSubMenus } from '@/utils/menuAccess';

export default {
    page: {
        title: "Credit Notes Listing",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Credit Notes Listing",
            items: [
                {
                text: "Invoice Listing",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            creditnoteList:[],
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
            date: '',
            key_search:'',
            program_id:null,
            programList:null,
            dtKey:0,
           
      
        };
    },

    methods: {
    getCurrency() {
            return process.env.VUE_CURRENCY || 'SGD';
        },

        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },

        formatDateToWeb(value){
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY')
            }
        },


        downloadExcel: function () {
            this.loadingDetail=true;
            const posting_ = {                
                date: this.date,
                key_search: this.key_search,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_AR_API_BASEURL+'export/creditNoteListingExport', posting_, {responseType: 'blob'})
            .then(response => {
                if (response) {
                    
                    console.log(response);
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
   
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'Credit Note List.xlsx');
                    document.body.appendChild(fileLink);
   
                    fileLink.click();
                    this.loadingDetail=false;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        getCreditNoteListing(){
            console.log('list credit note');
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'creditnotes/credits/customers/' + this.$route.params.id)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.creditnoteList = response.data;
                    console.log(this.creditnoteList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        searchCreditNotesForm(e)
        {
            this.loadingRoles=true,
            e.preventDefault()
            
            const posting_ = {                
                date: this.date,
                key_search: this.key_search,
                //program_id: this.program_id,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_AR_API_BASEURL+'creditnotes/searchCreditNote', posting_)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.creditnoteList = response.data;
                    this.dtKey +=1;
                    console.log(this.creditnoteList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
            this.loadingRoles=false;
        },

        resetForm: function () { 
            this.date = ''; 
            this.key_search = '';
            //this.program_id = '';  
            this.getCreditNoteListing();
        }

    },
  computed: {
    hasARModuleAccess() {
      return hasModuleAccess("AR Module");
    },
    accessibleSubMenus() {
      const subMenus = getSubMenus("AR Module");
      console.log("Accessible SubMenus:", subMenus);
      return subMenus;
    }
  },
    components: {
        DataTable,
        //flatPickr,
    },

    mounted() {
        this.getCreditNoteListing();
    },
    
};
require("@/assets/css/datatable.css");
</script>
<style>
/* .col-xl-8 {
    flex: 0 0 auto;
    width: 82.66667% !important;
} */
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!--button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#add_new_program_modal"  v-if="this.role = 1"><i class="ri-add-line align-middle me-1"></i> Add New Program</button> <br><br-->

        <div class="card">
            
            <div class="card-body">
                <!--h6>** Orders data display from {{lastthirtyday()}} to {{currentDate()}}</h6-->
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive" v-if="accessibleSubMenus.includes('credit notes')">
                                <DataTable :options="{lengthChange: false, ordering: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example"> 
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>#.</th>          
                                            <th scope="col">ID</th>           
                                            <th scope="col">Ref. No</th>
                                            <th scope="col">Issue Date</th>
                                            <th scope="col">Amount({{ this.getCurrency() }})</th>                                                            
                                            <th scope="col">Status</th>
                                            <th scope="col">Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in creditnoteList" :key="index" class="content">
                                            <td>{{ index+1 }}</td>
                                            <td>{{item.credit_notes_no}}</td>                               
                                            <td>{{ item.ar_invoice ? item.ar_invoice.invoice_no : '' }}</td>
                                            <td>{{formatDateToWeb(item.issue_date)}}</td>
                                            <td>{{parseFloat(item.total_amount).toFixed(2)}}</td>
                                            <td>{{item.status}}</td>
                                            <td>{{item.remarks}}</td>                                                               
                                            <!-- <td>
                                                <div class="dropdown">
                                                    <button class="btn btn-soft-secondary btn-sm dropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <i class="ri-more-fill align-middle"></i>
                                                    </button>
                                                    <ul class="dropdown-menu dropdown-menu-end">
                                                        <li>
                                                            <router-link class="dropdown-item" :to="'/ar/credit_notes/credit-note-details/'+item.id"><i class="ri-eye-fill align-bottom me-2 text-muted"></i> Credit Note Details</router-link>
                                                        </li>
                                                        <li class="dropdown-divider"></li>
                                                        <li>
                                                            <a class="dropdown-item remove-item-btn" @click="deletedata(item)"><i class="ri-delete-bin-fill align-bottom me-2 text-muted"></i> Delete</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>                                 -->
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            <div v-else class="text-center text-muted p-4">
                                You do not have permission to view credit notes.
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>